<app-filter-option icon="/assets/icons/geofence.svg" [title]="'FILTER.GEOFENCE.TITLE' | translate" (apply)="onApply()"
    (back)="onBack()">
    <app-multi-checkbox [optionArray]="geofenceOptions" (optionChange)="onOptionChange($event)"></app-multi-checkbox>
</app-filter-option>